// removed by extract-text-webpack-plugin
module.exports = {"root":"_3S15L"};